import React from "react";
import { useNavigate } from 'react-router-dom';
import styles from "./MentionsLegalesPage.module.scss"; // Stellen Sie sicher, dass eine entsprechende SCSS-Datei vorhanden ist

import Footer from '../../components/Footer/Footer';

const MentionsLegalesPage_De = () => {

  const navigate = useNavigate();

  return (
    <>
      <div className={styles.container}>
        <h1>Impressum</h1>

        <hr />
        <section>
          <h2>1. Herausgeber der Website / der Anwendung</h2>
          <p><strong>Name des Unternehmens oder des Herausgebers:</strong> Hatanna Éditions (Micro), vertreten durch Frau Célia Barbier.</p>
          <p><strong>Geschäftssitz:</strong> 173 Bd National 84400 APT</p>
          <p><strong>Handelsregisternummer (SIREN):</strong> 832486237</p>
          <p><strong>Kontakt-E-Mail:</strong> <a className={styles.link} href="mailto:contact@hatanna-editions.fr">contact@hatanna-editions.fr</a></p>
        </section>

        <section>
          <h2>2. Hosting</h2>
          <p><strong>Name des Hosters:</strong> OVH RCS Roubaix – Tourcoing 424 761 419 00045 Code APE 6202A</p>
          <p><strong>Adresse:</strong> 2 rue Kellermann - 59100 Roubaix - Frankreich</p>
        </section>

        <section>
          <h2>3. Geistiges Eigentum</h2>
          <p>
            Alle Inhalte der Anwendung (Texte, Bilder, Videos, Quellcodes, Design, Logo...)
            sind durch das Urheberrecht geschützt. Jede Vervielfältigung, Verbreitung oder Änderung
            ohne vorherige Genehmigung ist untersagt und kann zu rechtlichen Konsequenzen führen.
          </p>
        </section>

        <section>
          <h2>4. Persönliche Daten und Datenschutz</h2>
          <p>
            Die über die Anwendung erfassten Daten werden gemäß unserer
            <a className={styles.link} onClick={() => navigate("/privacy")} rel="noopener noreferrer"> Datenschutzrichtlinie</a>
            verarbeitet. Gemäß der <strong>Datenschutz-Grundverordnung (DSGVO)</strong> haben Sie das Recht,
            auf Ihre personenbezogenen Daten zuzugreifen, diese zu korrigieren oder zu löschen,
            indem Sie uns unter folgender Adresse kontaktieren: [Kontakt-E-Mail].
          </p>
        </section>

        <section>
          <h2>5. Haftung</h2>
          <p>
            Der Herausgeber der Anwendung kann nicht haftbar gemacht werden für:
          </p>
          <ul>
            <li>Vorübergehende Dienstunterbrechungen aufgrund von Wartungsarbeiten.</li>
            <li>Fehler oder Auslassungen in den angezeigten Inhalten.</li>
            <li>Schäden, die durch die Nutzung der Anwendung durch den Benutzer entstehen.</li>
          </ul>
        </section>

        <section>
          <h2>6. Hyperlinks</h2>
          <p>
            Die Anwendung kann Links zu externen Websites enthalten. Der Herausgeber übernimmt keinerlei Verantwortung
            für den Inhalt dieser Websites und für mögliche Konsequenzen aus deren Nutzung.
          </p>
        </section>

        <section>
          <h2>7. Anwendbares Recht</h2>
          <p>
            Dieses Impressum unterliegt dem französischen Recht (oder einer anderen Gerichtsbarkeit je nach Ihrem Land).
            Im Falle von Streitigkeiten sind die zuständigen Gerichte diejenigen des Geschäftssitzes des Herausgebers.
          </p>
        </section>

        <section>
          <h2>8. Entwicklung</h2>
          <p>
            Diese Anwendung wurde von <strong>Scriptales SAS</strong> entwickelt
            (<a className={styles.link} href="https://scriptales.fr" target="_blank" rel="noopener noreferrer">https://scriptales.fr</a>).
          </p>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default MentionsLegalesPage_De;
